export const AUTH_TOKEN_COOKIE_NAME = 'CS_AUTH_TOKEN';

export const AUTH_TYPE_COOKIE_NAME = 'CS_AUTH_TYPE';

export const AUTH_TYPES = {
  SSO: 'sso',
  CDI: 'cdi',
  OVI: 'ovi',
} as const;

export type AuthType = (typeof AUTH_TYPES)[keyof typeof AUTH_TYPES];

export const AUTH_TYPE_KEY = 'authType';
